import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { Button } from '../button';

export const $SignatureContainer = styled.div`
  position: relative;
  height: 100%;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};

  > canvas {
    width: 100%;
    height: 100%;
  }
`;

export const $SignatureClearButton = styled(Button)`
  position: absolute;
  bottom: ${spacing(2.5)};
  right: ${spacing(2.5)};
`;
